/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMCarouselItemListViewEvent } from '@/data/events/handlers/gtm/CarouselItemListView';
import { GTMCarouselItemListViewPayload } from '@/data/types/GTM';

type CarouselItemListViewDelegatorProps = {
	gtm?: GTMCarouselItemListViewPayload;
};

export const carouselItemListViewDelegator = async (
	payload: CarouselItemListViewDelegatorProps
) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMCarouselItemListViewEvent(gtm);
	}
};
